import './public-path';
import Vue from 'vue';
import App from './App.vue';
import Fragment from 'vue-fragment'
import ElementUI from 'element-ui';
import directives from '@/directive'
import 'element-ui/lib/theme-chalk/index.css';
import './components/GlobalComponent/index';
import './assets/css/base.less'
import './assets/style/dark-theme/theme-dark.less';
import './assets/style/light-theme/theme-light.less';
import './assets/style/light-theme/theme-stellar-light.less';
import './assets/css/common.less'
import './assets/css/public.less'
import { createRouter, destoryRouter, router } from '@/router';
import restMessage from './utils/resetMessage';
import EventManage from './utils/Evented'
import { isMicroAppMode, helper } from './microAdapt/utils'
import Theme from './microAdapt/theme'
import Plugins from '@/plugins/index'
import store from '@/store'

// import locale from './i18n/i18n';
import 'animate.css';
import '@/utils/requireSvg'
import '@/assets/css/fonts.css'
import '@/directive/index'
// import i18n from './i18n/i18n';

let instance = null;
function render(props = {}) {
    helper.initAssign(props)
    const { container } = props;
    // 解决element导航菜单动态渲染菜单数据后折叠菜单栏时文字不隐藏
    Vue.use(Fragment.Plugin);
    Vue.use(ElementUI);
    Vue.use(Plugins)
    Vue.use(directives)
    Vue.prototype.$message = restMessage;
    Vue.prototype.$eventManage = new EventManage();

    Vue.config.productionTip = false;

    createRouter({
        base: isMicroAppMode() ? '/appBlackHole/' : '/',
    })

    instance = new Vue({
        router,
        store,
        // i18n,
        render: (h) => h(App),
    }).$mount(container ? container.querySelector('#app') : '#app');
}


// 独立运行时（非微前端框架下）
if (!window.__POWERED_BY_QIANKUN__) {
    new Theme().setPrimaryColor();
    render();
}

// 下面是在微前端框架下运行的时候，qiankun 需要的钩子函数
export async function bootstrap() {
}


let controllerInstance = null

class Controller {
    constructor(props) {
        this.props = props
    }

    async uploadListVisible() {
        Vue.prototype.$eventManage.fire("open-dialog", { dialogType: 'uploadList' })
    }

    async transformListVisible() {
        Vue.prototype.$eventManage.fire("open-dialog", { dialogType: 'transformQueue' })
    }
}
export async function mount(props) {
    // 因为外面用了shadow dom 之后  打补丁
    // patchHelper.patchProxy(props)

    controllerInstance = new Controller(props)
    if (typeof props.getControllerInstance === 'function') {
        // 向外部抛出控制器，用来控制什么时候渲染什么页面
        props.getControllerInstance(controllerInstance)
    }
    render(props);
}
export async function unmount() {
    instance.$destroy();
    instance.$el.innerHTML = '';
    instance = null;
    destoryRouter()
    // 恢复补丁
    // patchHelper.revokeProxy()
}